import * as I18n from 'i18n-js';
import * as React from 'react';
import UrlHelpers from '../shared/url_helpers';
import { withUserContext, IUserContext } from '@reverbdotcom/commons/dist/components/user_context_provider';

interface IProps extends IUserContext {
  isSale?: boolean;
  isBrandPage?: boolean;
  slug?: string;
}

class CollectionHeaderEditButton extends React.Component<IProps> {
  get isUserAdmin() {
    return this.props.user?.isAdmin;
  }

  get shouldShowBrandEditButton() {
    return this.isUserAdmin && this.props.isBrandPage;
  }

  get shouldShowCuratedSetEditButton() {
    return this.isUserAdmin && this.props.isSale;
  }

  renderBrandEditButton() {
    if (!this.shouldShowBrandEditButton) {
      return null;
    }

    return (
      <a href={UrlHelpers.adminEditBrandPath(this.props.slug)}>
        {I18n.t('discovery.collectionHeader.edit')}
      </a>
    );
  }

  renderCuratedSetEditButton() {
    if (!this.shouldShowCuratedSetEditButton) {
      return null;
    }

    return (
      <a href={UrlHelpers.adminEditCuratedSetPath(this.props.slug)}>
        {I18n.t('discovery.collectionHeader.edit')}
      </a>
    );
  }

  render() {
    return (
      <span>
        {this.renderCuratedSetEditButton()}
        {this.renderBrandEditButton()}
      </span>
    );
  }
}

export default withUserContext(CollectionHeaderEditButton);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/collection_header_edit_button.tsx